<template>
  <modal class="question-modal" 
    :btn="editable ? 'Save' : 'Close'" :title="question.id ? question.question : 'New Question'" @close="$emit('close')"
    @submit="editable ? $emit('save') : $emit('close')" :disabled="saving">
        <v-alert type="info" :value="!editable" class="small-bottom">This survey is managed by Habit Technologies LLC and is not editable</v-alert>
        <h-textarea v-model="question.question" label="Question" messages="" :readonly="!editable" />
        <div class="help-text">*Questions are asked on a scale from 1-7 (Strongly Disagree to Strongly Agree)</div>

        <div class="small-top">
          <h-select label='Graph On' :items="dimensionChoices" v-model="question.dimension" item-text="name" item-value="id" :readonly="!editable" outline :error-messages="messages" />
        </div>
        <h-input type="checkbox" label="Always Ask" v-model="question.always" :readonly="!editable" />
        <v-alert type="info" :value='question.always'>This question will always be asked</v-alert>
        <v-alert type="info" :value='!question.always'>This question will be chosen at random</v-alert>
        <v-alert type="error" :value="error">{{error}}</v-alert>
        <div v-if="question.id && editable" class="space-between">
          <button type="button" @click="$emit('delete')">Delete</button>
        </div>
  </modal>
</template>

<script>
import modal from "@/components/modal/default";
export default {
  components: {
    modal
  },
  props: ["question", "display", "dimensions", "error", "editable"],
  data() {
    return {
      saving: false
    };
  },
  computed: {
    dimensionChoices() {
      return [{ name: "Not Graphed", id: null }, ...this.dimensions];
    },
    messages() {
      if (this.dimensions.length === 0) {
        return "You have not created any graphs yet";
      }
      return "";
    }
  }
};
</script>

<style lang="less">
.question-modal {
  .space-between {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .question-info {
    font-size: 14px;
  }
}
</style>
